import React, { Component } from 'react';

const CLIENT = 'ca-pub-7776683615756358';
const BANNER_SLOT = '3886344741';
const ARTICLE_SLOT = '8701356028';
const ARTICLE_LIST_SLOT = '4068046253';
const BOTTOM_SLOT = '7796496137';

class AdSense extends Component {
    componentDidMount() {
        if (window) (window.adsbygoogle = window.adsbygoogle || []).push({});
    }

    render() {
        return (
            <ins
                className="adsbygoogle"
                style={this.props.style}
                data-ad-client={CLIENT}
                data-ad-slot={this.props.slot}
                data-ad-layout={this.props.layout}
                data-ad-format={this.props.format}
                data-ad-layout-key={this.props.layoutKey}
            />
        );
    }
}

export const BannerAd = () => (
    <AdSense
        slot={BANNER_SLOT}
        format="auto"
        style={{ display: 'block', width: '100%' }}
    />
);

export const ArticleAd = () => (
    <AdSense
        slot={ARTICLE_SLOT}
        layout="in-article"
        format="fluid"
        style={{ display: 'block', textAlign: 'center', width: '100%' }}
    />
);

export const ArticleListAd = () => (
    <AdSense
        slot={ARTICLE_LIST_SLOT}
        layoutKey="-6t+ed+2i-1n-4w"
        format="fluid"
        style={{ display: 'block', width: '100%' }}
    />
);

export const BottomAd = () => (
    <AdSense
        slot={BOTTOM_SLOT}
        format="auto"
        style={{ display: 'block', width: '100%' }}
    />
);
